import { combineReducers } from 'redux'

import accessReducer from './accessSlice'
import activityReducer from './activity'
import alertReducer from './alert'
import allTasksTableReducer from './allTasksTable'
import articleReducer from './article'
import avatarReducer from './avatarSlice'
import baseInboxReducer from './baseInbox'
import categoryReducer from './category'
import chatBoxReducer from './chatBoxSlice'
import chatControlsReducer from './chatControlsSlice'
import contactsTableReducer from './contactsTable'
import convoReducer from './convo'
import customFieldsReducer from './customFields'
import customFieldGroupsReducer from './customFields/groups'
import dmsReducer from './dms'
import draftReducer from './draft'
import externalChannelsReducer from './externalChannel'
import extensionAPIReducer from './extensionAPI'
import favoritesReducer from './favorites'
import flowsReducer from './customFields/flows'
import inboxesReducer from './inboxes'
import mediaCacheReducer from './mediaCache'
import notificationReducer from './notification'
import pinnedTabsReducer from './pinnedTabs'
import presenceReducer from './presence'
import priorityReducer from './priority'
import reminderReducer from './reminder'
import roleReducer from './role'
import sentMediaReducer from './sentMedia'
import socketReducer from './socket'
import tagReducer from './tag'
import tasksReducer from './tasks'
import taskInputReducer from './taskInput'
import taskMetaReducer from './taskMetaCache'
import taskStatusReducer from './taskStatus'
import taskTypeReducer from './taskType'
import teamsReducer from './teamsSlice'
import timezoneReducer from './timezone'
import userReducer from './user'
import usersTableReducer from './usersTable'
import userStatusReducer from './userStatus'
import userTaskCacheReducer from './userTaskCache'
import userTypeReducer from './userType'
import viewsReducer from './views'
import widgetArticleReducer from './widgetArticles'

export default combineReducers({
  access: accessReducer,
  activity: activityReducer,
  alert: alertReducer,
  allTasksTable: allTasksTableReducer,
  article: articleReducer,
  avatar: avatarReducer,

  baseInbox: baseInboxReducer,

  category: categoryReducer,
  chatBox: chatBoxReducer,
  chatControls: chatControlsReducer,
  contactsTable: contactsTableReducer,
  convo: convoReducer,
  customFields: customFieldsReducer,
  customFieldGroups: customFieldGroupsReducer,

  dms: dmsReducer,
  draft: draftReducer,

  externalChannel: externalChannelsReducer,
  extensionAPI: extensionAPIReducer,

  favorites: favoritesReducer,
  flows: flowsReducer,

  inboxes: inboxesReducer,

  mediaCache: mediaCacheReducer,

  notification: notificationReducer,

  pinnedTabs: pinnedTabsReducer,
  presence: presenceReducer,
  priority: priorityReducer,

  reminder: reminderReducer,
  role: roleReducer,

  sentMedia: sentMediaReducer,
  socket: socketReducer,

  tag: tagReducer,
  tasks: tasksReducer,
  taskInput: taskInputReducer,
  taskMetaCache: taskMetaReducer,
  taskStatus: taskStatusReducer,
  taskType: taskTypeReducer,
  teams: teamsReducer,
  timezone: timezoneReducer,

  user: userReducer,
  usersTable: usersTableReducer,
  userStatus: userStatusReducer,
  userTaskCache: userTaskCacheReducer,
  userType: userTypeReducer,

  views: viewsReducer,

  widgetArticle: widgetArticleReducer
})
